module.exports = __webpack_public_path__ + "static/media/clear.d0842544.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clear.svg
// module id = 259
// module chunks = 0